// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Lcec","productName":"Table_productName__3Kzgn"};